import { buildUseT } from '@guiker/i18n'

export const useT = buildUseT({ domain: 'common' })
